import { render, staticRenderFns } from "./KDialog.vue?vue&type=template&id=4a5638d6&"
import script from "./KDialog.vue?vue&type=script&lang=js&"
export * from "./KDialog.vue?vue&type=script&lang=js&"
import style0 from "./KDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports